// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__30H0P","overflowing":"ReadFullNote_overflowing__3MBSL"};